/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon16Light = forwardRef('ArchiveCabinetIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M6.5 10a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 1A2.5 2.5 0 0 0 3 3.5v8A2.5 2.5 0 0 0 5.5 14h5a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 10.5 1h-5ZM12 7V3.5A1.5 1.5 0 0 0 10.5 2h-5A1.5 1.5 0 0 0 4 3.5V7h8ZM4 8h8v3.5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5V8Z" })));
});
